import { atom, DefaultValue } from 'recoil';

const localStorageEffect =
    (key) =>
        ({ setSelf, onSet }) => {
            const savedValue = localStorage.getItem(key);
            if (savedValue && savedValue !== 'undefined') {
                setSelf(JSON.parse(savedValue));
            }

            onSet((newValue) => {
                if (newValue instanceof DefaultValue) {
                    localStorage.removeItem(key);
                } else {
                    localStorage.setItem(key, JSON.stringify(newValue));
                }
            });
        };

const hostName = window?.location.hostname;

export const companiesState = atom({
    key: 'companiesState',
    default: [],
    effects_UNSTABLE: [localStorageEffect(`${hostName}_companies_state`)]
});

export const teamState = atom({
    key: 'teamState',
    default: [],
    effects_UNSTABLE: [localStorageEffect(`${hostName}_team_state`)]
});

export const homeState = atom({
    key: 'homeState',
    default: {},
    effects_UNSTABLE: [localStorageEffect(`${hostName}_home_state`)]
});